import React from 'react';
import { trans } from '@spotahome/soyuz/client';

import { useMediaQuery } from 'react-responsive';

import ServicePlan from './ServicePlan';
import { servicePlansEnum } from './servicePlanConfig';

import './ServicePlans.scss';

const MOBILE_MAX_WIDTH = 920;

const ServicePlans = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${MOBILE_MAX_WIDTH - 1}px)`
  });

  const renderNowAvailable = () => (
    <div className="service-plans__now-available">
      <div className="now-available__spacer" />
      <div className="now-available__content">
        <span className="now-available__text">
          {trans('landlord.landing.pricing-table.premium.available-cities')}
        </span>
      </div>
    </div>
  );

  const renderNowAvailableMobile = () => (
    <div className="service-plans__now-available">
      <span className="now-available__text">
        {trans('landlord.landing.pricing-table.premium.available-cities')}
      </span>
    </div>
  );

  return (
    <div className="service-plans">
      {!isMobile && renderNowAvailable()}
      <div className="service-plans__list">
        <ServicePlan servicePlan={servicePlansEnum.STANDARD} />
        {isMobile && renderNowAvailableMobile()}
        <ServicePlan servicePlan={servicePlansEnum.PREMIUM} />
      </div>
    </div>
  );
};

export default ServicePlans;
